import { Box, Flex } from '@hivewatch/dark'

import { NotificationsTab } from '@/features/notifications-tab'

import { Drawers } from './Drawers'
import { SideBar } from './SideBar'

interface DarkPageLayoutIProps {
  children?: React.ReactNode
  colorScheme: 'light' | 'dark'
}

export const DarkPageLayout = ({
  children,
  colorScheme,
}: DarkPageLayoutIProps) => {
  const appBackground = colorScheme === 'light' ? 'light.bg.app' : 'bg.app'

  return (
    <>
      <Box bg={appBackground} h='full'>
        <Flex h='full' minH={0}>
          <SideBar />
          <Box flex={1} minW={0} pos='relative'>
            {children}
          </Box>
        </Flex>
      </Box>
      <NotificationsTab />
      <Drawers />
    </>
  )
}
